// Spanish translations
const es = {
    translation: {
        // Common
        'app.name': 'Visual Remote Monitoring',
        'app.login': 'Acceder',
        'app.loginDemo': 'Demo Acceder',
        'app.register': 'Registrarse',
        'app.logout': 'Cerrar sesión',
        'common.dashboard': 'Dashboard',
        'common.installations': 'Lista de instalaciones',
        'app.news': 'Noticias',
        'news.overview': 'Resumen noticias',
        'news.searchPlaceholder': 'Buscar noticias...',
        'news.searchButton': 'Buscar',
        'news.noNewsFound': 'No se encontraron noticias.',
        'app.shop': 'Tienda',

        // Gallery
        'gallery.title': 'Galería de instalaciones',
        'gallery.share': 'Compartir',
        'gallery.shared': 'Compartido',
        'gallery.pending': 'Pendiente',
        'gallery.noImages': 'Sin imágenes',
        'gallery.like': 'Me gusta',
        'gallery.loginToLike': 'Inicie sesión para dar me gusta',
        'gallery.loadError': 'Error al cargar galería',
        'common.uploadImagesSuccess': 'Subida con éxito',
        'common.uploadImagesFailed': 'Error al subir',
        'gallery.deleteConfirm': '¿Eliminar esta imagen?',
        'gallery.maxImages': 'Máx. {{max}} imágenes',
        'gallery.caption': 'Descripción',
        'gallery.selectInstallation': 'Seleccionar instalación',
        'gallery.selectFiles': 'Seleccionar imágenes',
        'gallery.filesSelected': '{{count}} archivos seleccionados',
        'gallery.selectInstallationAndFiles': 'Seleccione instalación e imágenes',
        'gallery.shareToGallery': 'Compartir en galería pública',
        'gallery.myImages': 'Mis imágenes',
        'gallery.publicGallery': 'Galería pública',
        'gallery.unshare': 'Dejar de compartir',
        'gallery.unshared': 'No compartido',
        'gallery.subtitle': 'Comparta su instalación solar e inspire a otros',
        'gallery.dropOrClick': 'Arrastre o haga clic para subir',
        'gallery.private': 'Privado',
        'gallery.selectSource': 'Origen de imagen',
        'gallery.takePhoto': 'Tomar foto',
        'gallery.chooseFromGallery': 'de la Galería',
        'gallery.captionPlaceholder': 'Describa su instalación...',
        'gallery.shareHint': 'Permitir ver esta foto a otros',
        'common.uploadImagesHint': 'JPG, PNG (máx. 10MB)',

        'common.devices': 'Dispositivos',
        'app.profile': 'Perfil',
        'common.settings': 'Ajustes',
        'settings.verificationCode': 'Código de verificación',
        'settings.sendCode': 'Enviar código',
        'settings.codeSentNotice': 'Código de verificación enviado a su correo electrónico',
        'settings.codeRequired': 'Por favor ingrese el código de verificación de 6 dígitos',
        'app.language': 'Idioma',

        'app.email': 'Email',
        'common.password': 'Contraseña',
        'app.username': 'Usuario',
        'app.confirmPassword': 'Confirmar contraseña',
        'app.submit': 'Enviar',
        'common.cancel': 'Cancelar',
        'common.save': 'Guardar',
        'common.set': 'Escribir',
        'common.delete': 'Eliminar',
        'common.add': 'Añadir',
        'common.upload': 'Subir',
        'common.edit': 'Editar',
        'common.search': 'Buscar',
        'common.filter': 'Filtrar',
        'common.sort': 'Ordenar',
        'common.status': 'Estado',
        'common.online': 'En línea',
        'common.offline': 'Offline',
        'common.error': 'Error',
        'common.success': 'Éxito',
        'app.back': 'Atrás',
        'app.home': 'Inicio',
        'common.actions': 'Acciones',
        'common.loading': 'Cargando...',
        'common.processing': 'Procesando...',
        'common.close': 'Cerrar',
        'common.units': 'Unidades',
        'common.normal': 'Normal',
        'common.tooHigh': 'Muy alto',
        'common.tooLow': 'Muy bajo',
        'common.number': 'Número',
        'common.time': 'Hora',
        'common.overview': 'Resumen',
        'common.details': 'Detalles',
        'common.rowsPerPage': 'Filas por pág.',
        'common.readMore': 'Leer más',
        // Unified terms (reuse across pages)
        'common.voltage': 'Voltaje',
        'common.current': 'Corriente',
        'common.power': 'Potencia',
        'common.temperature': 'Temperatura',
        'common.soc': 'SOC',
        'common.charging': 'Cargando',
        'common.discharging': 'Descargando',
        'common.idle': 'Inactivo',
        'common.warning': 'Aviso',
        'common.warnState1': 'Estado aviso 1',
        'common.warnState2': 'Estado aviso 2',
        'common.cell': 'Celda',
        'common.avgVoltage': 'Voltaje prom.',
        'common.avgTemperature': 'Temp. prom.',
        'common.totalCurrent': 'Corriente total',
        'common.totalPower': 'Potencia total',
        'common.fullyCharged': 'Cargado',
        'common.user': 'Usuario',
        'common.deviceId': 'ID Disp.',
        'common.unknownWarning': 'Aviso desc.',
        'common.admin': 'Admin',
        'common.protection': 'Protección',
        'common.fault': 'Falla',
        'common.calibration': 'Calibración',
        'common.refresh': 'Actualizar',
        'common.addDevice': 'Añadir disp.',
        'common.deviceAdded': 'Dispositivo añadido',
        'common.cycleCount': 'Ciclos',
        'common.soh': 'SOH',
        'common.realtime': 'Monitoreo tiempo real',
        'common.batteryPackTitle': 'Pack batería #{{index}}',
        'common.remainCapacityAh': 'Cap. restante (Ah)',
        'common.fullChargeCapacityAh': 'Cap. total (Ah)',
        'common.designCapacityAh': 'Cap. diseño (Ah)',
        'common.backToDetail': 'Volver a detalles',
        'common.loadDeviceFailed': 'Error al cargar detalles',
        'common.permissionsManagement': 'Gestión de permisos',
        'common.shortCircuitProt': 'Protección cortocircuito',
        'common.startDate': 'Fecha inicio',
        'common.endDate': 'Fecha fin',
        // Status & States
        'common.expired': 'Expirado',
        // Actions
        'common.create': 'Crear',
        // Time-related
        'common.day': 'día',
        'common.days': 'días',
        'common.createdAt': 'Creado el',
        'common.expiry': 'Fecha exp.',
        'common.expiryDays': 'Validez (días)',
        // Battery-related
        'common.batteryPack': 'Batería',
        'common.dischargeEnabled': 'Descarga hab.',
        'common.chargeEnabled': 'Carga hab.',
        'common.currentLimit': 'Límite corr.',
        'common.charger': 'Cargador',
        'common.avg': 'Prom.',


        // Device
        'device.lastConnection': 'Últ. conexión',
        'device.delete': 'Eliminar inst.',
        'device.view': 'Ver disp.',
        'device.notFound': 'No encontrado',
        'device.deleteSuccess': 'Instalación eliminada',
        'device.confirmDelete': '¿Borrar esta instalación?',
        'device.info': 'Información instalación',
        'device.details': 'Detalles inst.',
        'device.never': 'Nunca',
        'device.errorMissingFields': 'Complete campos oblig.',
        'device.idHelp': 'ID único del disp.',
        'device.nameHelp': 'Nombre del disp.',
        'device.loading': 'Cargando disp...',
        'common.justNow': 'Recién',
        'device.minutesAgo': 'minutos',
        'device.hoursAgo': 'horas',
        'device.noDevicesDesc': 'Todavía no ha añadido ningún dispositivo. Haga clic en el botón de abajo para añadir su primer dispositivo.',
        'device.deleting': 'Eliminando...',
        'device.noConnections': 'Sin conexiones rec.',
        'device.type': 'Tipo disp.',
        'device.optionalInfo': 'Info opcional',
        'device.optionalInfoTooltip': 'Nos ayuda a dar mejor soporte',
        'device.inverterBrand': 'Marca inversor',
        'device.inverterModel': 'Modelo inversor',
        'device.solarPower': 'Potencia solar (kW)',
        'device.city': 'Ciudad inst.',
        'device.description': 'Descripción inst.',
        'device.updatedAt': 'Act. el',

        // Battery data
        'battery.status': 'Estado carga',
        'battery.data': 'Datos batería',
        'battery.history': 'Historial',
        'battery.protectionRecord': 'Registro prot.',
        'battery.balance': 'Corriente balanceo',
        'battery.cells': 'Cant. celdas',
        'battery.noData': 'Sin datos',
        'battery.historyCharts': 'Gráficos hist.',
        'battery.resetZoom': 'Reset',

        'battery.cellData': 'Datos celdas',
        'battery.cellVoltageData': 'Datos volt. celdas',
        'battery.temperatureData': 'Datos sensores temp.',
        'battery.cellDataUnavailable': 'Celdas no disp., mostrando datos prev.',
        'battery.tempDataUnavailable': 'Sensores no disp., mostrando datos prev.',
        'battery.cellVoltageTable': 'Tabla volt. celdas',
        'battery.tempDataTable': 'Tabla temperaturas',
        'battery.cellStats': 'Estadísticas celdas',
        'battery.activeBalancing': 'Balanceo activo',
        'battery.activeBalancingOn': 'Balanceando',
        'battery.heaterEnabled': 'Calentador hab.',
        'battery.currentLimitEnabled': 'Límite corr. hab.',
        'battery.highest': 'Máx.',
        'battery.lowest': 'Mín.',
        'battery.highestVoltage': 'Voltaje máx.',
        'battery.lowestVoltage': 'Voltaje mín.',
        'battery.volDiff': 'Dif. voltaje',
        'battery.totalCells': 'Total celdas',
        'battery.temperatureSensors': 'Sensores temp.',
        'battery.temperatureStats': 'Estadísticas temp.',
        'battery.sensorCount': 'Cant. sensores',
        'battery.highestTemperature': 'Temp. máx.',
        'battery.lowestTemperature': 'Temp. mín.',
        'battery.faultState': 'Estado falla',
        'battery.protectState1': 'Estado prot. 1',
        'battery.protectState2': 'Estado prot. 2',

        // Warning titles
        'warning.title': 'Información avisos',
        'warning.current': 'Avisos actuales',
        'warning.normal': 'Estado normal, sin avisos',
        'warning.noWarning': 'Sin avisos',

        // Protection state related
        'warning.protect_high_discharge_current': 'Prot. sobrecorr. descarga',
        'warning.protect_high_charge_current': 'Prot. sobrecorr. carga',
        'warning.protect_low_total_voltage': 'Prot. subvoltaje total',
        'warning.protect_high_total_voltage': 'Prot. sobrevoltaje total',
        'warning.protect_low_cell_voltage': 'Prot. subvoltaje celda',
        'warning.protect_high_cell_voltage': 'Prot. sobrevoltaje celda',
        'warning.protect_low_env_temp': 'Prot. temp. amb. baja',
        'warning.protect_high_env_temp': 'Prot. temp. amb. alta',
        'warning.protect_high_mos_temp': 'Prot. temp. MOS alta',
        'warning.protect_low_discharge_temp': 'Prot. temp. descarga baja',
        'warning.protect_low_charge_temp': 'Prot. temp. carga baja',
        'warning.protect_high_discharge_temp': 'Prot. temp. descarga alta',
        'warning.protect_high_charge_temp': 'Prot. temp. carga alta',

        // Command state related
        'battery.reverse_connected': 'Inversión polaridad bat.',

        // Fault state related
        'warning.fault_sampling': 'Falla muestreo',
        'warning.fault_cell': 'Falla celda',
        'warning.fault_ntc': 'Falla sensor temp.',
        'warning.fault_discharge_mos': 'Falla MOS descarga',
        'warning.fault_charge_mos': 'Falla MOS carga',
        'warning.fault_adapter_temp': 'Sobretemp. placa adapt.',
        'warning.fault_virtual_connection': 'Conexión bat. floja',
        'warning.fault_communication': 'Falla comunicación',
        'warning.fault_ccb': 'Falla CCB',
        'warning.fault_heater': 'Falla calentador',
        'warning.fault_12v': 'Falla pot. 12V',
        'warning.fault_total_voltage': 'Falla volt. total',
        'warning.fault_temp_diff': 'Falla dif. temp.',
        'warning.fault_detect_resistor': 'Falla resist. detec.',
        'warning.fault_trip_unit': 'Falla unidad disparo',
        'warning.fault_master_slave': 'Falla comunic. M/S',
        'warning.fault_bms_lock': 'BMS bloqueado',
        'warning.fault_mcu_overvoltage': 'Sobrevoltaje MCU',

        'warning.protect_short_circuit': 'Prot. cortocircuito',
        'warning.protect_charger_overvoltage': 'Prot. sobrevolt. cargador',
        'warning.protect_full_charge': 'Prot. carga completa',

        // Status indicators
        'status.limit_current_on': 'Límite corr. ACT.',
        'status.limit_current_off': 'Límite corr. DES.',
        'status.charge_mos_on': 'MOS carga ACT.',
        'status.charge_mos_off': 'MOS carga DES.',
        'status.discharge_mos_on': 'MOS descarga ACT.',
        'status.discharge_mos_off': 'MOS descarga DES.',
        'status.charger_connected': 'Cargador con.',
        'status.charger_disconnected': 'Cargador desc.',
        'status.heater_on': 'Calent. ACT.',
        'status.heater_off': 'Calent. DES.',

        // Warning state 1 related
        'warning.warn_high_discharge_current': 'Aviso sobrecorr. descarga',
        'warning.warn_high_charge_current': 'Aviso sobrecorr. carga',
        'warning.warn_low_total_voltage': 'Aviso subvoltaje total',
        'warning.warn_high_total_voltage': 'Aviso sobrevoltaje total',
        'warning.warn_low_cell_voltage': 'Aviso subvoltaje celda',
        'warning.warn_high_cell_voltage': 'Aviso sobrevoltaje celda',

        // Warning state 2 related
        'warning.warn_low_soc': 'Aviso SOC bajo',
        'warning.warn_high_mos_temp': 'Aviso temp. MOS alta',
        'warning.warn_low_env_temp': 'Aviso temp. amb. baja',
        'warning.warn_high_env_temp': 'Aviso temp. amb. alta',
        'warning.warn_low_discharge_temp': 'Aviso temp. desc. baja',
        'warning.warn_low_charge_temp': 'Aviso temp. carga baja',
        'warning.warn_high_discharge_temp': 'Aviso temp. desc. alta',
        'warning.warn_high_charge_temp': 'Aviso temp. carga alta',

        // Warning states
        'warning.below_lower_limit': 'Bajo límite inf.',
        'warning.above_upper_limit': 'Sobre límite sup.',
        'warning.user_defined': 'Def. por usuario',
        'warning.other_fault': 'Otra falla',

        // Warning descriptions (for tooltip)
        'warningDesc.warn_low_soc': 'El SOC de la batería está por debajo del umbral de seguridad, por favor cárguela a tiempo',
        'warningDesc.warn_high_mos_temp': 'La temperatura del MOS es demasiado alta, lo que puede afectar la eficiencia de carga y descarga',
        'warningDesc.warn_low_env_temp': 'La temperatura ambiente es demasiado baja, lo que puede afectar el rendimiento de la batería',
        'warningDesc.warn_high_env_temp': 'La temperatura ambiente es demasiado alta, por favor preste atención a la disipación de calor',
        'warningDesc.warn_low_discharge_temp': 'La temperatura de descarga es demasiado baja, la descarga ha sido limitada',
        'warningDesc.warn_low_charge_temp': 'La temperatura de carga es demasiado baja, la carga ha sido limitada',
        'warningDesc.warn_high_discharge_temp': 'La temperatura de descarga es demasiado alta, la descarga ha sido limitada',
        'warningDesc.warn_high_charge_temp': 'La temperatura de carga es demasiado alta, la carga ha sido limitada',
        'warningDesc.warn_high_discharge_current': 'La corriente de descarga excede el límite de seguridad',
        'warningDesc.warn_high_charge_current': 'La corriente de carga excede el límite de seguridad',
        'warningDesc.warn_low_total_voltage': 'El voltaje total está por debajo del umbral de seguridad',
        'warningDesc.warn_high_total_voltage': 'El voltaje total está por encima del umbral de seguridad',
        'warningDesc.warn_low_cell_voltage': 'El voltaje de la celda es demasiado bajo',
        'warningDesc.warn_high_cell_voltage': 'El voltaje de la celda es demasiado alto',
        'warningDesc.protect_high_discharge_current': 'La corriente de descarga es demasiado alta, se ha activado la protección',
        'warningDesc.protect_high_charge_current': 'La corriente de carga es demasiado alta, se ha activado la protección',
        'warningDesc.protect_short_circuit': 'Se ha detectado un cortocircuito, se ha activado la protección',
        'warningDesc.protect_low_total_voltage': 'El voltaje total es demasiado bajo, se ha activado la protección',
        'warningDesc.protect_high_total_voltage': 'El voltaje total es demasiado alto, se ha activado la protección',
        'warningDesc.protect_low_cell_voltage': 'El voltaje de la celda es demasiado bajo, se ha activado la protección',
        'warningDesc.protect_high_cell_voltage': 'El voltaje de la celda es demasiado alto, se ha activado la protección',
        'warningDesc.protect_low_env_temp': 'La temperatura ambiente es demasiado baja, se ha activado la protección',
        'warningDesc.protect_high_env_temp': 'La temperatura ambiente es demasiado alta, se ha activado la protección',
        'warningDesc.protect_high_mos_temp': 'La temperatura del MOS es demasiado alta, se ha activado la protección',
        'warningDesc.protect_low_discharge_temp': 'La temperatura de descarga es demasiado baja, se ha activado la protección',
        'warningDesc.protect_low_charge_temp': 'La temperatura de carga es demasiado baja, se ha activado la protección',
        'warningDesc.protect_high_discharge_temp': 'La temperatura de descarga es demasiado alta, se ha activado la protección',
        'warningDesc.protect_high_charge_temp': 'La temperatura de carga es demasiado alta, se ha activado la protección',
        'warningDesc.fault_sampling': 'El circuito de muestreo de la batería es anormal, por favor revise el hardware',
        'warningDesc.fault_cell': 'Falla en la celda de la batería, por favor revise el pack de baterías',
        'warningDesc.fault_ntc': 'Falla en el sensor de temperatura, incapaz de medir la temperatura con precisión',
        'warningDesc.fault_discharge_mos': 'Falla en el MOS de descarga, incapaz de descargar normalmente',
        'warningDesc.fault_charge_mos': 'Falla en el MOS de carga, incapaz de cargar normalmente',
        'warningDesc.fault_adapter_temp': 'La temperatura de la placa adaptadora es demasiado alta',
        'warningDesc.fault_virtual_connection': 'El contacto de la batería es deficiente, por favor verifique la conexión',

        // Authentication
        'auth.loginTitle': 'Acceda a su cuenta',
        'auth.registerTitle': 'Crear nueva cuenta',
        'auth.forgotPassword': '¿Olvidó su contraseña?',
        'auth.noAccount': '¿No tiene cuenta?',
        'auth.haveAccount': '¿Ya tiene cuenta?',
        'auth.loginSuccess': 'Sesión iniciada',
        'auth.registerSuccess': 'Registro con éxito',
        'auth.registerFailed': 'Error al registrar',
        'auth.logoutSuccess': 'Sesión cerrada',
        'auth.invalidCredentials': 'Email o contraseña inválidos',
        'auth.passwordMismatch': 'Las contraseñas no coinciden',
        'auth.emailExists': 'El email ya está registrado',
        'auth.usernameExists': 'El usuario ya está registrado',
        'auth.managerEmail': 'Email admin (opcional)',
        'auth.managerEmailHelp': 'Email de su admin para unirse a su equipo',
        'auth.invitationCode': 'Código invitación (opcional)',
        'auth.invitationCodeHelp': 'Ingrese código si posee uno',
        'auth.forgotPasswordDesc': 'Por favor, ingrese su dirección de correo electrónico registrada y le enviaremos un enlace para restablecer su contraseña.',
        'auth.forgotPasswordSuccess': 'Correo electrónico de restablecimiento enviado. Por favor, revise su bandeja de entrada.',
        'auth.invalidToken': 'Token no válido',
        'auth.tokenErrorDesc': 'Token de restablecimiento no válido o ausente. Por favor, acceda a esta página desde el enlace de su correo electrónico.',
        'auth.passwordUpdated': 'Contraseña act. con éxito. Redirigiendo...',
        'auth.resetPasswordTitle': 'Resetear contraseña',

        // Settings
        'settings.about': 'Acerca de',
        'settings.aboutDesc': 'Home Battery IoT es un sistema de monitoreo para dispositivos de baterías domésticos.',
        'settings.languageUpdated': 'Idioma actualizado con éxito',
        'settings.updateFailed': 'Error al act. ajustes',
        'settings.changePassword': 'Cambiar contraseña',
        'settings.currentPassword': 'Contraseña actual',
        'settings.newPassword': 'Nueva contraseña',
        'settings.confirmPassword': 'Confirmar nueva contr.',
        'settings.passwordUpdated': 'Contraseña cambiada',
        'settings.passwordMismatch': 'No coinciden',
        'settings.passwordTooShort': 'Min. 6 caracteres',
        'settings.usernameUpdated': 'Usuario actualizado',
        'settings.appearance': 'Ajustes de apariencia',
        'settings.avatar': 'Avatar',
        'settings.changeAvatar': 'Cambiar avatar',
        'settings.avatarHint': 'Máx 2MB (JPG/PNG/GIF/WebP)',
        'settings.avatarUpdated': 'Avatar actualizado',
        'settings.invalidFileType': 'Seleccione una imagen',
        'settings.fileTooLarge': 'Imagen muy grande (máx 2MB)',
        'settings.timezone': 'Zona horaria',
        'settings.timezoneUpdated': 'Zona horaria act.',

        // Timezone labels
        'timezones.UTC': 'UTC (Hora Universal Coordinada)',
        'timezones.Europe/London': 'Londres (GMT/BST)',
        'timezones.Europe/Dublin': 'Dublín (GMT/IST)',
        'timezones.Europe/Paris': 'París (CET/CEST)',
        'timezones.Europe/Berlin': 'Berlín (CET/CEST)',
        'timezones.Europe/Amsterdam': 'Ámsterdam (CET/CEST)',
        'timezones.Europe/Brussels': 'Bruselas (CET/CEST)',
        'timezones.Europe/Rome': 'Roma (CET/CEST)',
        'timezones.Europe/Madrid': 'Madrid (CET/CEST)',
        'timezones.Europe/Lisbon': 'Lisboa (WET/WEST)',
        'timezones.Europe/Vienna': 'Viena (CET/CEST)',
        'timezones.Europe/Zurich': 'Zúrich (CET/CEST)',
        'timezones.Europe/Stockholm': 'Estocolmo (CET/CEST)',
        'timezones.Europe/Oslo': 'Oslo (CET/CEST)',
        'timezones.Europe/Copenhagen': 'Copenhague (CET/CEST)',
        'timezones.Europe/Helsinki': 'Helsinki (EET/EEST)',
        'timezones.Europe/Warsaw': 'Varsovia (CET/CEST)',
        'timezones.Europe/Prague': 'Praga (CET/CEST)',
        'timezones.Europe/Athens': 'Atenas (EET/EEST)',
        'timezones.Europe/Istanbul': 'Estambul (TRT)',
        'timezones.Europe/Moscow': 'Moscú (MSK)',
        'timezones.America/New_York': 'Nueva York (EST/EDT)',
        'timezones.America/Toronto': 'Toronto (EST/EDT)',
        'timezones.America/Chicago': 'Chicago (CST/CDT)',
        'timezones.America/Denver': 'Denver (MST/MDT)',
        'timezones.America/Phoenix': 'Phoenix (MST)',
        'timezones.America/Los_Angeles': 'Los Ángeles (PST/PDT)',
        'timezones.America/Vancouver': 'Vancouver (PST/PDT)',
        'timezones.America/Anchorage': 'Anchorage (AKST/AKDT)',
        'timezones.Pacific/Honolulu': 'Honolulu (HST)',
        'timezones.America/Mexico_City': 'Ciudad de México (CST/CDT)',
        'timezones.America/Bogota': 'Bogotá (COT)',
        'timezones.America/Lima': 'Lima (PET)',
        'timezones.America/Santiago': 'Santiago (CLT/CLST)',
        'timezones.America/Sao_Paulo': 'São Paulo (BRT)',
        'timezones.America/Buenos_Aires': 'Buenos Aires (ART)',
        'timezones.Asia/Jerusalem': 'Jerusalén (IST)',
        'timezones.Asia/Beirut': 'Beirut (EET/EEST)',
        'timezones.Asia/Amman': 'Amán (EET/EEST)',
        'timezones.Asia/Baghdad': 'Bagdad (AST)',
        'timezones.Asia/Kuwait': 'Kuwait (AST)',
        'timezones.Asia/Dubai': 'Dubái (GST)',
        'timezones.Asia/Muscat': 'Mascate (GST)',
        'timezones.Asia/Riyadh': 'Riad (AST)',
        'timezones.Asia/Qatar': 'Doha (AST)',
        'timezones.Asia/Bahrain': 'Baréin (AST)',
        'timezones.Asia/Tehran': 'Teherán (IRST)',
        'timezones.Asia/Kabul': 'Kabul (AFT)',
        'timezones.Asia/Karachi': 'Karachi (PKT)',
        'timezones.Asia/Tashkent': 'Taskent (UZT)',
        'timezones.Asia/Almaty': 'Almaty (ALMT)',
        'timezones.Asia/Kolkata': 'Mumbai / Nueva Delhi (IST)',
        'timezones.Asia/Colombo': 'Colombo (IST)',
        'timezones.Asia/Kathmandu': 'Katmandú (NPT)',
        'timezones.Asia/Dhaka': 'Daca (BST)',
        'timezones.Asia/Yangon': 'Rangún (MMT)',
        'timezones.Asia/Bangkok': 'Bangkok (ICT)',
        'timezones.Asia/Ho_Chi_Minh': 'Ciudad Ho Chi Minh (ICT)',
        'timezones.Asia/Jakarta': 'Yakarta (WIB)',
        'timezones.Asia/Singapore': 'Singapur (SGT)',
        'timezones.Asia/Kuala_Lumpur': 'Kuala Lumpur (MYT)',
        'timezones.Asia/Manila': 'Manila (PHT)',
        'timezones.Asia/Hong_Kong': 'Hong Kong (HKT)',
        'timezones.Asia/Shanghai': 'Shanghái / Pekín (CST)',
        'timezones.Asia/Taipei': 'Taipéi (CST)',
        'timezones.Asia/Seoul': 'Seúl (KST)',
        'timezones.Asia/Tokyo': 'Tokio (JST)',
        'timezones.Australia/Perth': 'Perth (AWST)',
        'timezones.Australia/Adelaide': 'Adelaida (ACST/ACDT)',
        'timezones.Australia/Brisbane': 'Brisbane (AEST)',
        'timezones.Australia/Sydney': 'Sídney (AEST/AEDT)',
        'timezones.Australia/Melbourne': 'Melbourne (AEST/AEDT)',
        'timezones.Pacific/Auckland': 'Auckland (NZST/NZDT)',
        'timezones.Africa/Casablanca': 'Casablanca (WET/WEST)',
        'timezones.Africa/Algiers': 'Argel (CET)',
        'timezones.Africa/Tunis': 'Túnez (CET)',
        'timezones.Africa/Tripoli': 'Trípoli (EET)',
        'timezones.Africa/Cairo': 'El Cairo (EET)',
        'timezones.Africa/Khartoum': 'Jartum (CAT)',
        'timezones.Africa/Addis_Ababa': 'Adís Abeba (EAT)',
        'timezones.Africa/Nairobi': 'Nairobi (EAT)',
        'timezones.Africa/Lagos': 'Lagos (WAT)',
        'timezones.Africa/Accra': 'Acra (GMT)',
        'timezones.Africa/Johannesburg': 'Johannesburgo (SAST)',
        'timezones.Africa/Cape_Town': 'Ciudad del Cabo (SAST)',

        'common.uploading': 'Subiendo...',

        // Errors
        'error.pageNotFound': 'Página no encontrada',
        'error.pageNotFoundDesc': 'La página que está buscando puede haber sido eliminada, renombrada o no estar disponible temporalmente.',
        'error.fetchFailed': 'Error al obtener datos',
        'error.createFailed': 'Error al crear',
        'error.copyFailed': 'Error al copiar',
        'error.processFailed': 'Error al procesar solicitud',

        // Admin
        'admin.dashboard': 'Panel admin',
        'admin.superDashboard': 'Panel superadmin',
        'admin.managedUsers': 'Gestión usuarios',
        'admin.managedDevices': 'Gestión disp.',
        'admin.role': 'Rol',
        'admin.superadmin': 'Superadmin',
        'admin.noUsers': 'Sin usuarios',
        'admin.userList': 'Lista usuarios',
        'admin.adminList': 'Lista admins',
        'admin.deviceList': 'Lista disp.',
        'admin.noAdmins': 'Sin admins',
        'admin.addAdmin': 'Añadir admin',
        'admin.createError': 'Error crear admin',
        'admin.fillAllFields': 'Complete todo',
        'admin.deviceCount': 'Cant. disp.',
        'admin.assignManager': 'Asignar admin',
        'admin.selectManager': 'Seleccionar admin',
        'admin.noManager': 'Sin admin (quitar)',
        'admin.assigningUser': 'Asignando usuario',
        'admin.assign': 'Asignar',
        'admin.assignError': 'Error al asignar',
        'admin.self': 'Yo',
        'admin.active': 'Activo',
        'admin.used': 'Usado',
        'admin.adminPanel': 'Panel de admin',
        'admin.newsManagement': 'Gestión Noticias',
        'admin.addNews': 'Añadir noticia',
        'admin.editNews': 'Editar noticia',
        'admin.deleteNews': 'Borrar noticia',
        'admin.deleteNewsConfirm': '¿Borrar esta noticia?',
        'admin.newsTitle': 'Título',
        'admin.newsSummary': 'Resumen',
        'admin.newsContent': 'Contenido',
        'admin.newsImageUrl': 'URL imagen',
        'admin.newsPublished': 'Publicado',
        'admin.newsDraft': 'Borrador',
        'admin.newsStatus': 'Estado',
        'admin.newsCreateSuccess': 'Noticia creada con éxito',
        'admin.newsUpdateSuccess': 'Noticia act. con éxito',
        'admin.newsDeleteSuccess': 'Noticia borrada con éxito',

        // Invitation code management
        'admin.invitationManagement': 'Gestión de invitaciones',
        'admin.createInvitation': 'Crear invitación',
        'admin.invitationCode': 'Código inv.',
        'admin.invitationCreated': 'Invitación creada',
        'admin.copy': 'Copiar',
        'admin.codeCopied': 'Copiado al portapapeles',
        'admin.noInvitations': 'Sin invitaciones',

        // Authorization request related
        'user.authRequests': 'Sols. autorización',
        'user.authRequestManagement': 'Gestión de sols.',
        'user.createAuthRequest': 'Crear sol. autoriz.',
        'user.authCode': 'Código autoriz.',
        'user.authRequestCreated': 'Solicitud creada con éxito',
        'user.shareAuthLink': 'Compartir link autoriz.',
        'user.shareAuthLinkHelp': 'Envíe a un admin para que gestione su cuenta',
        'user.linkCopied': 'Link copiado',
        'user.copyLink': 'Copiar link',
        'user.share': 'Compartir',
        'user.shareLink': 'Compartir link',
        'user.authRequestHelp': 'Sol. acceso a un admin para su cuenta',
        'user.authRequestShareTitle': 'Autoriz. Gestión Batería IoT',
        'user.authRequestShareText': 'Por favor autoríceme como su admin',
        'common.noAuthRequests': 'Sin sols. autoriz.',
        'user.pending': 'Pendiente',
        'user.accepted': 'Aceptada',
        'user.rejected': 'Rechazada',

        'admin.authRequestReview': 'Revisión sols. autoriz.',
        'admin.authRequestDetails': 'Detalles solicitud',
        'admin.authRequestLoadError': 'Error al cargar sols.',
        'admin.requestCode': 'Código sol.',
        'admin.createdBy': 'Creado por',
        'admin.processedBy': 'Proc. por',
        'admin.processedAt': 'Proc. el',
        'admin.unknownUser': 'Usuario desc.',
        'admin.accept': 'Aceptar',
        'admin.reject': 'Rechazar',
        'admin.authRequestAccepted': 'Sol. aceptada',
        'admin.authRequestRejected': 'Sol. rechazada',
        'admin.authRequestNotForAdmin': 'Solo para usuarios. Admins solo revisan y procesan.',

        // Battery pack details
        'battery.packageDetails': 'Detalles batería',

        'battery.basicInfo': 'Info básica',
        'battery.cellCount': 'Cant. celdas',
        'battery.tempSensorCount': 'Cant. sensores temp.',
        'battery.chargeCurrentStatus': 'Estado corr. carga',
        'battery.totalVoltageStatus': 'Estado volt. total',
        'battery.dischargeCurrentStatus': 'Estado corr. descarga',
        'battery.controlStatus': 'Estado control y comandos',
        'battery.instructionState': 'Estado bat.',
        'battery.controlState': 'Estado control',
        'battery.chargerAvailable': 'Cargador disp.',
        'battery.warningStatus': 'Aviso y Falla',
        'battery.led_warning': 'Aviso LED',
        'battery.buzzer_warning': 'Aviso zumbador',
        'battery.freq_shift': 'Despl. frec.',
        'battery.parallelStatus': 'Estado sist. paralelo',
        'battery.parallelCount': 'Cant. bat. paralelo',
        'battery.avgCycleCount': 'Ciclos prom.',
        'battery.cycleCountUnit': 'ciclos',


        'battery.standby': 'Standby',
        'battery.cellVoltage': 'Voltaje celda',
        'battery.batteryPackUnavailable': 'Descuectada temp., mostrando últ. datos...',
        'battery.normalStatus': 'Pack normal, sin avisos ni fallas',
        'battery.warn_high_charge_temp': 'Temp. carga alta',

        // Dashboard new content
        'dashboard.soc': 'SOC',
        'dashboard.voltage': 'Voltaje total',
        'dashboard.current': 'Corriente total',
        'dashboard.temperature': 'Temp. máx.',
        'dashboard.systemStatus': 'Estado sistema',
        'dashboard.totalDevices': 'Disp. totales',
        'dashboard.onlineDevices': 'Disp. online',
        'dashboard.deviceStatus': 'Estado disp.',
        'dashboard.batteryStatus': 'Estado bat.',
        'dashboard.powerStatus': 'Estado potencia',
        'dashboard.temperatureStatus': 'Estado temp.',
        'dashboard.avgSOC': 'SOC prom.',
        'dashboard.types': 'Tipos',
        'dashboard.batteryHistory': 'Historial batería',
        'dashboard.voltageHistory': 'Hist. voltaje',
        'dashboard.currentHistory': 'Hist. corriente',
        'dashboard.socHistory': 'Hist. SOC',
        'dashboard.temperatureHistory': 'Hist. temperatura',
        'dashboard.lastHour': 'Últ. hora',
        'dashboard.last6Hours': 'Últ. 6 h',
        'dashboard.lastDay': 'Últ. 24 h',
        'dashboard.lastWeek': 'Últ. semana',
        'dashboard.lastMonth': 'Últ. mes',
        'dashboard.batteryDetails': 'Detalles bat.',
        'dashboard.deviceAnalysis': 'Análisis disp.',
        'dashboard.systemOverview': 'Resumen sistema',
        'dashboard.deviceTypeDistribution': 'Distrib. tipos disp.',
        'dashboard.voltageAndCurrentOverview': 'Resumen Voltaje y Corriente',
        'dashboard.onlinePercentage': 'Porcentaje online',
        'dashboard.noAlerts': 'Sin registros de alerta',

        // Dashboard page specific
        'dashboard.totalInstallations': 'Instalaciones totales',
        'dashboard.viewAllInstallations': 'Ver todas',
        'dashboard.activeInstallations': 'Inst. activas',
        'dashboard.allInstallations': 'Todas las inst.',
        'dashboard.systemAlertsNotices': 'Alertas y notificaciones',
        'dashboard.deviceOffline': 'Disp. offline',
        'dashboard.deviceOfflineDesc': 'El dispositivo {{name}} ({{id}}) se encuentra actualmente fuera de línea. Por favor, compruebe la conexión.',
        'dashboard.deviceAlarm': 'Alerta de dispositivo',
        'dashboard.deviceAlarmDesc': 'El dispositivo {{name}} ({{id}}) tiene alertas activas. Por favor, compruebe el estado del dispositivo.',
        'dashboard.systemNormal': 'Sistema Normal',
        'dashboard.systemNormalDesc': 'Todos los sistemas están funcionando normalmente.',
        'dashboard.latestNews': 'Noticias producto',

        // InstallationList page
        'installations.loadError': 'Error al cargar lista.',
        'installations.noInstallations': 'Sin instalaciones.',
        'installations.realtime': 'T. real',
        'installations.oldData': 'Datos viejos',
        'installations.batteries': 'Baterías',
        'installations.lastUpdate': 'Últ. act.',
        'installations.deviceName': 'Nombre inst. (opc.)',
        'installations.deviceNamePlaceholder': 'Mi sist. batería',
        'installations.deviceNameHelper': 'Nombre amigable',
        'installations.deviceIdRequired': 'El ID del dispositivo es obligatorio',
        'installations.deviceIdPlaceholder': 'Ver ID en etiqueta WIFI',
        'installations.deviceClaimed': 'Vinculado con éxito',
        'installations.addFailed': 'Error al añadir',
        'installations.otherType': 'Otro',


        // Installation Detail page
        'detail.backToList': 'A la lista',
        'detail.installationDetail': 'Detalles inst.',
        'detail.installationName': 'Nombre inst.',
        'detail.owner': 'Dueño',
        'detail.batteryCount': 'Cant. bat.',
        'detail.realtimeMetrics': 'Métricas T. Real',
        'detail.avgSOC': 'SOC prom.',
        'detail.avgSOH': 'SOH prom.',
        'detail.maxCellVol': 'Voltaje máx. celda',
        'detail.minCellVol': 'Voltaje mín. celda',
        'detail.cellVolDiff': 'Dif. volt. celda',

        // Battery Detail page
        'battery.packDetail': 'Detalles pack #{{index}}',

        'battery.packNotFound': 'Datos no hallados',
        'battery.loadError': 'Error cargar datos',

        // Battery Overview
        'battery.packVoltage': 'Voltaje pack',
        'battery.packCurrent': 'Corriente pack',
        'battery.packPower': 'Potencia pack',
        'battery.chargerConnected': 'Cargador con.',
        'battery.fullEnergy': 'Energ. total',
        'battery.remainEnergy': 'Energ. rest.',

        'common.yes': 'Sí',
        'common.no': 'No',
        'common.on': 'Encendido',
        'common.off': 'Apagado',
        'common.ongoing': 'En curso',


        // RealTime Monitor
        'battery.cellVoltages': 'Voltajes celdas',
        'battery.temperatures': 'Monitoreo temperaturas',

        // History Charts
        'battery.historyTrends': 'Tendencias hist.',
        'battery.voltageCurrent': 'Voltaje y Corriente',

        'battery.dragToSelect': 'Arrastre p/ seleccionar r. de tiempo',

        'battery.alarmDetails': 'Detalles alarma',
        'battery.noActiveAlarms': 'Sin alarmas activas',
        'battery.sensor': 'Sensor',
        'battery.issue': 'Problema',
        'battery.tempSensorIssues': 'Problemas sensores temp.',

        // Charts & Widgets
        'battery.minCellVoltage': 'Voltaje mín. celda',
        'battery.maxCellVoltage': 'Voltaje máx. celda',


        'battery.mosTemp': 'Temp. MOS',
        'battery.envTemp': 'Temp. ambiente',
        'battery.otherTemps': 'Otras temperaturas',


        'battery.noDataAvailable': 'Sin datos',
        'battery.fetchError': 'Error historial',
        'battery.generalError': 'Ocurrió un error',

        // Settings - Common
        'settings.recover': 'Recup.',
        'settings.delay': 'Retraso',
        'settings.unitV': 'Unidad: V',
        'settings.unitA': 'Unidad: A',
        'settings.unitMs': 'Unidad: ms',
        'settings.unitUs': 'Unidad: μs',
        'settings.unitC': 'Unidad: °C',
        'settings.charge': 'Carga',
        'settings.discharge': 'Descarga',
        'settings.high': 'Alto',
        'settings.low': 'Bajo',
        'settings.description': 'Descripción',
        'settings.read': 'Leer',
        'settings.setting': 'Ajustando...',
        'settings.readSuccess': 'Leído con éxito',
        'settings.timeout': 'Tiempo agotado',
        'settings.operationFailed': 'Falla op.',
        'settings.failed': 'Falla',
        'settings.jkReadOnlyNote': 'La configuración de JK BMS se actualiza automáticamente mediante transmisión y es de solo lectura en este sistema.',
        'settings.lastUpdated': 'Última actualización',
        'settings.chargeHighTemp': 'Alta temp. de carga',
        'settings.dischargeHighTemp': 'Alta temp. de descarga',
        'settings.designCapacity': 'Capacidad de diseño',
        'settings.balanceMaxCurrent': 'Corr. máx. de equilibrio',
        'settings.balanceTriggerDiff': 'Dif. de equilibrio',

        // Settings - Control Tab
        'settings.mosControl': 'Control MOS',
        'settings.chargeMosControl': 'Control MOS Carga',
        'settings.openChargeMos': 'Hab. carga',
        'settings.closeChargeMos': 'Des. carga',
        'settings.dischargeMosControl': 'Control MOS Descarga',
        'settings.openDischargeMos': 'Hab. descarga',
        'settings.closeDischargeMos': 'Des. descarga',
        'settings.powerManagement': 'Control Energía',
        'settings.shutdownSleep': 'Apagar/Reposo',
        'settings.opening': 'Abriendo...',
        'settings.closing': 'Cerrando...',
        'settings.executing': 'Ejecutando...',

        // Settings - Protection Tab
        'settings.protGroup1': 'Parámetros Prot. de Voltaje',
        'settings.cellOvercharge': 'Sobrecarga de celda',
        'settings.cellOverchargeDesc': 'Cuando el voltaje de la celda excede continuamente el valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga. Después de activar la protección, cuando todos los voltajes de las celdas caigan por debajo del valor de recuperación, el sistema restaurará la función de carga.',
        'settings.cellOverdischarge': 'Sobredescarga de celda',
        'settings.cellOverdischargeDesc': 'Cuando el voltaje de la celda cae continuamente por debajo del valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la descarga. Después de activar la protección, cuando todos los voltajes de las celdas suban por encima del valor de recuperación, el sistema restaurará la función de descarga.',
        'settings.totalOvercharge': 'Sobrecarga total',
        'settings.totalOverchargeDesc': 'Cuando el voltaje total excede continuamente el valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga. Después de activar la protección, cuando todos los voltajes de las celdas caigan por debajo del valor de recuperación, el sistema restaurará la función de carga.',
        'settings.totalOverdischarge': 'Sobredescarga total',
        'settings.totalOverdischargeDesc': 'Cuando el voltaje total cae continuamente por debajo del valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la descarga. Después de activar la protección, cuando todos los voltajes de las celdas suban por encima del valor de recuperación, el sistema restaurará la función de descarga.',
        'settings.protGroup2': 'Parámetros de protección de corriente',
        'settings.chargeOvercurrent': 'Sobrecorriente de carga',
        'settings.chargeOvercurrentDesc': 'El valor de advertencia es la corriente de carga máxima solicitada al inversor. Cuando la corriente de carga excede continuamente el valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga.',
        'settings.dischargeOvercurrent1': 'Sobrecorriente de descarga 1',
        'settings.dischargeOvercurrent1Desc': 'El valor de advertencia es la corriente de descarga máxima solicitada al inversor. Cuando la corriente de descarga excede continuamente el valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la descarga.',
        'settings.dischargeOvercurrent2': 'Sobrecorriente de descarga 2',
        'settings.dischargeOvercurrent2Desc': 'Cuando la corriente de descarga excede continuamente el valor de protección durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la descarga.',
        'settings.maxChargeCurrent': 'Límite de corriente de carga',
        'settings.maxChargeCurrentDesc': 'El Límite de Corriente de Carga (CCL) se refiere a la corriente de carga máxima permitida que un solo módulo de batería informa al inversor en condiciones normales de funcionamiento. Cuando N módulos de batería están conectados en paralelo, la corriente de carga máxima total solicitada por el sistema de batería al inversor es la suma de los CCL de los módulos individuales, es decir, CCL × N. EL valor de protección se refiere al umbral de corriente al que un solo módulo de batería activa la protección contra sobrecorriente. El CCL debe establecerse por debajo del valor de protección.',
        'settings.maxDischargeCurrent': 'Límite de corriente de descarga',
        'settings.maxDischargeCurrentDesc': 'El Límite de Corriente de Descarga (DCL) se refiere a la corriente de descarga máxima permitida que un solo módulo de batería informa al inversor en condiciones normales de funcionamiento. Cuando N módulos de batería están conectados en paralelo, la corriente de descarga máxima total solicitada por el sistema de batería al inversor es la suma de los DCL de los módulos individuales, es decir, DCL × N. El valor de protección se refiere al umbral de corriente al que un solo módulo de batería activa la protección contra sobrecorriente. El DCL debe establecerse por debajo del valor de protección.',
        'settings.maxChargeVoltage': 'Límite de voltaje de carga',
        'settings.maxChargeVoltageDesc': 'El Límite de Voltaje de Carga (CVL) es el voltaje total máximo solicitado por el sistema de batería al inversor.',
        'settings.chargeVoltageLimitV': 'CVL (V)',
        'settings.chargeCurrentLimitA': 'CCL (A)',
        'settings.dischargeCurrentLimitA': 'DCL (A)',
        'settings.shortCircuitDesc': 'Cuando se detecta un cortocircuito durante el retraso establecido, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga y la descarga.',
        'settings.protGroup3': 'Parámetros de protección de temperatura',
        'settings.tempHigh': 'Protección por alta temperatura',
        'settings.tempHighDesc': 'Cuando la temperatura excede el valor de protección, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga o descarga. Después de activar la protección, cuando la temperatura caiga por debajo del valor de recuperación, el sistema restaurará la función de carga o descarga.',
        'settings.tempLow': 'Protección por baja temperatura',
        'settings.tempLowDesc': 'Cuando la temperatura cae por debajo del valor de protección, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga o descarga. Después de activar la protección, cuando la temperatura suba por encima del valor de recuperación, el sistema restaurará la función de carga o descarga. Cuando la temperatura cae por debajo del valor de advertencia de carga, la función de calefacción se activa automáticamente. Cuando la temperatura sube al valor de recuperación de carga, la función de calefacción se apaga automáticamente.',
        'settings.mosTempHigh': 'Protección por alta temperatura de MOS',
        'settings.mosTempHighDesc': 'Cuando la temperatura del MOS es superior al valor de protección, el BMS ejecuta inmediatamente la acción de protección y detiene por la fuerza la carga y la descarga. Después de activar la protección, cuando la temperatura del MOS cae por debajo del valor de recuperación, el sistema restaura la función de carga o descarga.',
        'settings.envTemp': 'Protección por temperatura ambiente',
        'settings.envTempDesc': 'Cuando la temperatura ambiente excede el valor de protección de alta temperatura o cae por debajo del valor de protección de baja temperatura, el BMS ejecutará inmediatamente la acción de protección y forzará la detención de la carga o descarga. Después de activar la protección, cuando la temperatura ambiente regrese al rango de temperatura de recuperación correspondiente, el sistema restaurará automáticamente la función de carga o descarga.',

        'settings.enableProtection': 'Hab. protección',
        'settings.chargeTempProt': 'Prot. temp. carga',
        'settings.dischargeTempProt': 'Prot. temp. descarga',

        // Settings - History Tab
        'settings.historyManagement': 'Gestión historial',
        'settings.reading': 'Leyendo...',
        'settings.readHistory': 'Leer registros (1-40)',
        'settings.stopReading': 'Parar lectura',
        'settings.clearHistory': 'Borrar historial',
        'settings.messages.historyReadComplete': '¡Leído! {{count}} registros hallados',
        'settings.historyRecords': 'Historial ({{count}} rec.)',
        'settings.record': 'Registro {{index}}',
        'settings.timeUnknown': 'Hora desc.',
        'settings.cellInfo': 'Info celdas ({{count}})',
        'settings.tempSensors': 'Sensores ({{count}})',
        'settings.statusInfo': 'Info estado',
        'settings.noHistoryFound': 'Sin historial',
        'settings.clearHistoryResult': 'Resultado borrado',
        'settings.confirmClearHistory': 'Confirmar borrado',
        'settings.confirmClearHistoryDesc': '¿Está seguro de que desea borrar todos los registros históricos del BMS?',
        'settings.clearHistoryWarning': '¡Op. irreversible! Se borrarán datos del disp.',
        'settings.confirmDelete': 'Borrar',

        // Settings - Protocol Tab
        'settings.inverterProtocolConfig': 'Conf. protocolo inversor',
        'settings.protocolSelectDesc': 'Elija el protocolo de comunicación inversora correspondiente de la lista desplegable.',
        'settings.canProtocol': 'Prot. CAN',
        'settings.rs485Protocol': 'Prot. RS485',
        'settings.selectCanProtocol': 'Elegir CAN',
        'settings.selectRs485Protocol': 'Elegir RS485',

        // Settings - System Tab
        'settings.mainBatterySettings': 'Ajustes pack maestro',
        'settings.systemConfig': 'Conf. batería',
        'settings.otherConfig': 'Otros ajustes',
        'settings.timeSettings': 'Ajustes hora',
        'settings.timeSettingsDesc': 'La hora del sistema dentro del BMS. Se recomienda sincronizarla regularmente con la hora local de su teléfono para una mayor precisión.',
        'settings.syncTime': 'Sinc. hora local',
        'settings.bmsTime': 'Hora BMS',
        'settings.capacitySettings': 'Ajustes capacidad',
        'settings.capacitySettingsDesc': 'La capacidad restante afecta directamente al porcentaje de SOC. La capacidad nominal es el valor de fábrica, mientras que la capacidad total es la capacidad de funcionamiento actual.',
        'settings.batterySeries': 'Cant. series',
        'settings.batterySeriesDesc': 'El valor predeterminado es 16 cuerdas. Por favor, ajústelo según su instalación real.',
        'settings.batterySeriesHelper': 'Número de celdas en serie',
        'settings.cycleCount': 'Recuento de ciclos',
        'settings.cycleCountDesc': 'El número de ciclos de batería se acumula automáticamente, pero puede corregirse manualmente aquí si es necesario.',
        'settings.cycleCountHelper': 'Ciclos carga/descarga',
        'settings.fullChargeParams': 'Parám. carga completa',
        'settings.fullChargeParamsDesc': 'Condiciones de juicio para alcanzar el 100% de carga de la batería.',
        'settings.fullChargeCutoffVoltage': 'Volt. corte (V)',
        'settings.fullChargeCutoffCurrent': 'Corr. corte (A)',
        'settings.lowCapacityAlarm': 'Alarma SOC bajo (%)',
        'settings.capacityRelease': 'Liberación capacidad',
        'settings.capacityReleaseDesc': 'Un punto de referencia de SOC para la liberación de capacidad.',
        'settings.socValue': 'Valor SOC (%)',
        'settings.socRange': 'Rango: 74-97',
        'settings.currentZero': 'Cero corriente',
        'settings.currentZeroDesc': 'Calibración automática del sensor de corriente cuando no hay carga ni descarga. El valor predeterminado es 0.',
        'settings.correctionValue': 'Corrección (0.1A)',
        'settings.refVoltage': 'Volt. referencia',
        'settings.refVoltageDesc': 'Se utiliza para calibrar la referencia de muestreo de voltaje de la celda. Introduzca el voltaje medido real en milivoltios.',
        'settings.actualVoltageMv': 'Volt. real (mV)',
        'settings.totalVoltage': 'Volt. total',
        'settings.totalVoltageDesc': 'Introduzca el voltaje total medido con un comprobador de voltaje externo para calibrar el BMS.',
        'settings.actualTotalVoltageMv': 'Volt. total real (mV)',
        'settings.chargeCurrent': 'Corr. carga',
        'settings.chargeCurrentDesc': 'Introduzca la corriente de carga medida actualmente (A) para calibrar el BMS.',
        'settings.actualCurrentA': 'Corr. real (A)',
        'settings.dischargeCurrent': 'Corr. descarga',
        'settings.dischargeCurrentDesc': 'Introduzca la corriente de descarga medida actualmente (A) para calibrar el BMS.',
        'settings.systemInfo': 'Info sistema',
        'settings.versionInfo': 'Versión',
        'settings.versionInfoDesc': 'Información sobre la versión del hardware y firmware interno del BMS.',
        'settings.internalVersion': 'Vers. firmware',
        'settings.internalVersionHelper': 'Versión interna',
        'settings.restoreDefault': 'Volver a fábrica',
        'settings.restoreDefaultDesc': 'Restablece todos los parámetros del BMS a sus valores originales de fábrica.',
        'settings.restoreDefaultBtn': 'Restaurar defecto',
        'settings.restoring': 'Restaurando...',

        // Settings - Permissions Tab
        'settings.permissionsDesc': 'Gestione los permisos de acceso para otros usuarios en esta instalación.',
        'settings.shareSuccess': 'Invita. env. a {{email}}',
        'settings.shareFailed': 'Error al compartir',
        'settings.removeAccessSuccess': 'Acceso quitado',
        'settings.removeAccessFailed': 'Error al quitar acceso',
        'settings.loadingUsers': 'Cargando usuarios...',
        'settings.noSharedUsers': 'Inst. no compartida',
        'settings.noPermission': 'Sin permisos de gestión.',
        'settings.userEmail': 'Email usuario',
        'settings.accessLevel': 'Nivel acceso',
        'settings.readOnly': 'Solo lectura',
        'settings.readWrite': 'Lec/Esc',
        'settings.sharing': 'Compartiendo...',
        'settings.shareDevice': 'Compartir inst.',
        'settings.usersWithAccess': 'Usuarios c/ acceso',
        'settings.remove': 'Quitar',

        // Settings - SettingsLogTab
        'settings.modificationLog': 'Log de cambios ajustes',
        'settings.loadHistoryFailed': 'Error log cambios',
        'settings.noChangesFound': 'Sin cambios',
        'settings.logSetting': 'Ítem ajuste',
        'settings.na': 'N/D',

        // Settings - Params Mapping (Log Types)
        'settings.enabled': 'Hab.',
        'settings.controlMode': 'Modo control',
        'settings.delayMs': 'Retr. (ms)',
        'settings.unknown': 'Desc.',
        'settings.alarmVoltage': 'Alarma (mV)',
        'settings.chargeAlarmVoltage': 'Alarma carga (mV)',
        'settings.dischargeAlarmVoltage': 'Alarma desc. (mV)',
        'settings.protectionVoltage': 'Prot. (mV)',
        'settings.recoveryVoltage': 'Recup. (mV)',
        'settings.alarmVoltageV': 'Alarma (V)',
        'settings.protectionVoltageV': 'Prot. (V)',
        'settings.recoveryVoltageV': 'Recup. (V)',
        'settings.alarmCurrentA': 'Alarma (A)',
        'settings.protectionCurrentA': 'Prot. (A)',
        'settings.recoveryCurrentA': 'Recup. (A)',
        'settings.chargeProtectionCurrentA': 'Prot. carga (A)',
        'settings.delayUs': 'Retr. (μs)',
        'settings.alarmCurrentMa': 'Alarma (mA)',
        'settings.protectionCurrentMa': 'Prot. (mA)',
        'settings.recoveryCurrentMa': 'Recup. (mA)',
        'settings.alarmTemp': 'Alarma (°C)',
        'settings.protectionTemp': 'Prot. (°C)',
        'settings.recoveryTemp': 'Recup. (°C)',
        'settings.chargeHighTempAlarm': 'Alarma carga temp. alta (°C)',
        'settings.chargeHighTempProtection': 'Prot. carga temp. alta (°C)',
        'settings.chargeHighTempRecovery': 'Recup. carga temp. alta (°C)',
        'settings.dischargeHighTempAlarm': 'Alarma desc. temp. alta (°C)',
        'settings.dischargeHighTempProtection': 'Prot. desc. temp. alta (°C)',
        'settings.dischargeHighTempRecovery': 'Recup. desc. temp. alta (°C)',
        'settings.chargeLowTempAlarm': 'Alarma carga temp. baja (°C)',
        'settings.chargeLowTempProtection': 'Prot. carga temp. baja (°C)',
        'settings.chargeLowTempRecovery': 'Recup. carga temp. baja (°C)',
        'settings.dischargeLowTempAlarm': 'Alarma desc. temp. baja (°C)',
        'settings.dischargeLowTempProtection': 'Prot. desc. temp. baja (°C)',
        'settings.dischargeLowTempRecovery': 'Recup. desc. temp. baja (°C)',
        'settings.envHighTempAlarm': 'Alarma amb. temp. alta (°C)',
        'settings.envHighTempProtection': 'Prot. amb. temp. alta (°C)',
        'settings.envHighTempRecovery': 'Recup. amb. temp. alta (°C)',
        'settings.envLowTempAlarm': 'Alarma amb. temp. baja (°C)',
        'settings.envLowTempProtection': 'Prot. amb. temp. baja (°C)',
        'settings.envLowTempRecovery': 'Recup. amb. temp. baja (°C)',
        'settings.socPercent': 'SOC (%)',
        'settings.sleepVoltageMv': 'Volt. reposo (mV)',
        'settings.sleepDelayMin': 'Retr. reposo (min)',
        'settings.chargeDelayMs': 'Retr. carga (ms)',
        'settings.chargeProtectionCurrentMa': 'Ref. corr. carga (mA)',
        'settings.dischargeDelayMs': 'Retr. descarga (ms)',

        // Balance Settings
        'settings.balance': 'Ajustes balanceo activo',
        'settings.balanceDesc': 'Ajuste el umbral de voltaje para iniciar el equilibrado de celdas. El equilibrador se activará cuando el voltaje de la celda sea superior a este valor.',
        'settings.balanceStartVoltage': 'Volt. inicio',
        'settings.balanceStartDiff': 'Dif. inicio',
        'settings.balanceStartVoltageMv': 'Volt. inicio (mV)',
        'settings.balanceStartDiffMv': 'Dif. inicio (mV)',

        // JK BMS Ajustes - Protección voltaje pack
        'jk.noSettingsData': 'Sin datos de ajustes aún. Los ajustes se actualizan cuando el BMS transmite una trama SETUP.',
        'jk.chargeVoltages': 'Voltajes de Carga',
        'jk.socSettings': 'Ajustes de SOC',
        'jk.packVoltageProtection': 'Protección voltaje pack',
        'jk.packOVP': 'Voltaje de Flotación',
        'jk.packUVP': 'Voltaje Máx. de Carga del Inversor',
        'jk.floatVoltage': 'Voltaje de Flotación',
        'jk.inverterMaxChargeVoltage': 'Voltaje Máx. de Carga del Inversor',
        'jk.soc100Voltage': 'Voltaje SOC 100%',
        'jk.soc0Voltage': 'Voltaje SOC 0%',
        'jk.smartSleepVoltage': 'Voltaje reposo inteligente',
        'jk.autoPowerOffVoltage': 'Voltaje apagado auto.',
        // JK BMS Ajustes - Protección corriente
        'jk.currentProtection': 'Protección corriente',
        'jk.chargeOC': 'Límite corriente carga',
        'jk.chargeOCPDelay': 'Retraso OCP carga',
        'jk.chargeOCPRelease': 'Liberación OCP carga',
        'jk.dischargeOC': 'Límite corriente descarga',
        'jk.dischargeOCPDelay': 'Retraso OCP descarga',
        'jk.dischargeOCPRelease': 'Liberación OCP descarga',
        'jk.scpRelease': 'Liberación SCP',
        // JK BMS Ajustes - Configuración batería
        'jk.batteryConfig': 'Configuración batería',
        'jk.cellCount': 'Cant. celdas',
        'jk.chargeSwitch': 'Interruptor carga',
        'jk.dischargeSwitch': 'Interruptor descarga',
        'jk.balanceSwitch': 'Interruptor balanceo',
        'jk.scpDelay': 'Retraso SCP',
        // JK BMS Ajustes - Configuración dispositivo
        'jk.deviceConfig': 'Configuración dispositivo',
        'jk.deviceAddress': 'Dirección dispositivo',
        'jk.prechargeDelay': 'Retraso precarga',
        'jk.smartSleepTime': 'Tiempo reposo inteligente',
        'jk.heatEnabled': 'Calefacción',
        'jk.tempSensorDisabled': 'Sensor temp. desactivado',
        'jk.gpsHeartbeat': 'Heartbeat GPS',
        'jk.portSwitch': 'Puerto (RS485)',
        'jk.lcdAlwaysOn': 'LCD siempre encendido',
        'jk.specialCharger': 'Cargador especial',
        'jk.smartSleepEnabled': 'Reposo inteligente',
        'jk.disablePCLModule': 'Desact. módulo PCL',
        'jk.timedStoredData': 'Datos almacenados periód.',
        'jk.chargingFloatMode': 'Modo flotante de carga',

        'settings.fullCharge': 'Carga completa',
        'settings.cellSleep': 'Reposo celdas',
        'settings.cellSleepDesc': 'Cuando el voltaje de la celda cae por debajo del voltaje de reposo durante más tiempo que el tiempo de retraso, la batería entrará en modo de reposo para ahorrar energía.',
        'settings.inverterProtocol': 'Protocolo',

        // InstallationSettings Main Page
        'settings.title': 'Ajustes instalación',
        'settings.sendCommandFailed': 'Falla al enviar comando',
        'settings.confirmShutdown': 'Apagar/Reposo',
        'settings.confirmShutdownDesc': 'Esta acción apagará el BMS. Deberá encenderlo físicamente en el sitio para restaurar la conexión.',

        // Tabs
        'settings.tabs.control': 'Control',
        'settings.tabs.protection': 'Ajustes Prot.',
        'settings.tabs.protocol': 'Ajustes Protoc.',
        'settings.tabs.system': 'Ajustes Sist.',
        'settings.tabs.log': 'Log ajustes',

        // Messages
        'settings.messages.fetchingProtocolSettings': 'Cargando protoc. act...',
        'settings.messages.fetchProtocolListFailed': 'Error lista protocol. inversor',
        'settings.messages.fetchingHistory': 'Leyendo historial...',
        'settings.messages.startReadingHistory': 'Iniciando lectura historial...',
        'settings.messages.readingHistoryProgress': 'Leyendo {{current}}/{{total}}...',
        'settings.messages.protocolSetSuccess': 'Protocolo act. con éxito',
        'settings.messages.protocolListSuccess': 'Lista obtenida con éxito',
        'settings.messages.protocolListComplete': '¡Leído! {{count}} protoc. hallados',
        'settings.messages.protocolListCompleteCan': '¡Leído! {{count}} protoc. CAN hallados',
        'settings.messages.fetchingProtocolIds': 'Obteniendo IDs...',
        'settings.messages.fetchingCanNames': 'Obteniendo nombres CAN...',
        'settings.messages.fetchingRs485Names': 'Obteniendo nombres RS485...',

        // Support System
        'support.title': 'Soporte Técnico',
        'support.newPost': 'Nuevo post',
        'support.editPost': 'Editar post',
        'support.searchPlaceholder': 'Buscar posts...',
        'support.filterByTag': 'Filtrar por tag',
        'support.allTags': 'Todo',
        'support.products': 'Productos',
        'support.categories': 'Categorías',
        'support.sortBy': 'Orden',
        'support.sortLatest': 'Últimos',
        'support.sortPopular': 'Popular',
        'support.sortUnsolved': 'Sin rta.',
        'support.sortMostViewed': 'Más vistos',
        'support.loadError': 'Error datos soporte',
        'support.noSearchResults': 'Sin coincidencias.',
        'support.noPosts': 'Sin posts.',
        'support.createFirstPost': 'Cree su primer post',
        'support.minutesAgo': 'hace {{count}} min',
        'support.hoursAgo': 'hace {{count}} h',
        'support.daysAgo': 'hace {{count}} d',
        'support.pinned': 'Fijado',
        'support.locked': 'Bloqueado',
        'support.resolved': 'Resuelto',
        'support.private': 'Privado',
        'support.views': 'Vistas',
        'support.replies': 'Respuestas',
        'support.noReplies': 'Sin rtas. aún',
        'support.backToList': 'A la lista',
        'support.postNotFound': 'Post no hallado',
        'support.accessDenied': 'Acceso denegado',
        'support.addReply': 'Responder',
        'support.replyPlaceholder': 'Su respuesta...',
        'support.submitReply': 'Enviar rta.',
        'support.loginToReply': 'Acceda para rta.',
        'support.postLocked': 'Cerrado',
        'support.bestAnswer': 'Mejor rta.',
        'support.markBestAnswer': 'Marcar mejor rta.',
        'support.unmarkBestAnswer': 'Quitar mejor rta.',
        'support.confirmDelete': 'Borrar',
        'support.confirmDeletePost': '¿Borrar este post?',
        'support.confirmDeleteReply': '¿Borrar rta.?',
        'support.pin': 'Fijar',
        'support.unpin': 'Quitar fijo',
        'support.lock': 'Bloquear',
        'support.unlock': 'Desbloquear',
        'support.statusOpen': 'Abierto',
        'support.statusResolved': 'Resuelto',
        'support.statusClosed': 'Cerrado',
        'support.postTitle': 'Título',
        'support.titlePlaceholder': 'Breve título',
        'support.postContent': 'Contenido',
        'support.contentPlaceholder': 'Describa su problema...',
        'support.selectProduct': 'Elegir producto',
        'support.noProduct': 'Ninguno',
        'support.selectCategory': 'Elegir categoría',
        'support.categoryRequired': 'Elija categoría',
        'support.announcementAdminOnly': 'Solo admins',
        'support.titleContentRequired': 'Título/Contenido oblig.',
        'support.linkDevice': 'Vincular disp.',
        'support.linkDeviceDescription': 'Adjunte datos de diagnóstico de uno de sus dispositivos.',
        'support.selectDevice': 'Elegir disp.',
        'support.noDevice': 'Ninguno',
        'support.packIndex': 'Índice pack',
        'support.linkedDeviceSnapshot': 'Captura disp. vinc.',
        'support.linkedDeviceSettings': 'Ajustes disp. vinc.',
        'support.publicPost': 'Público',
        'support.privatePost': 'Privado',
        'support.publicDescription': 'Cualquier usuario podrá ver el contenido de este post',
        'support.privateDescription': 'Solo el personal de soporte técnico podrá ver el contenido de este post',
        'support.submitPost': 'Enviar post',
        'support.saveDraft': 'Guardar borrador',
        'support.draftSaved': 'Borrador guardado',
        'support.similarPostsFound': 'Posts similares:',
        'support.createError': 'Error crear post',

        // Phase 2 additions
        'support.myPosts': 'Mis posts',
        'support.myPostsTab': 'Mis posts',
        'support.draftsTab': 'Borradores',
        'support.noMyPosts': 'Aún no publicó',
        'support.untitledDraft': 'Sin título',
        'support.lastSaved': 'Últ. guard.',
        'support.continueDraft': 'Seguir',
        'support.deleteDraft': 'Borrar borrador',
        'support.noDrafts': 'Sin borradores',
        'support.addImages': 'Fotos',
        'support.maxFilesError': 'Máx {{max}} fotos',
        'support.onlyImagesAllowed': 'Solo imágenes',
        'support.fileTooLarge': 'Imagen muy grande (máx 10MB)',
        'support.uploadFailed': 'Error al subir',
        'common.uploadImages': 'Subir imgs',

        // Phase 3 additions
        'support.mentioning': 'Mencionando',

        // Phase 4 additions
        'support.adminPanel': 'Gestión Soporte',
        'support.tagsTab': 'Gestión Tags',
        'support.templatesTab': 'Plantillas Rta.',
        'support.reportsTab': 'Gestión Reportes',
        'support.addTag': 'Añadir Tag',
        'support.editTag': 'Editar Tag',
        'support.tagType': 'Tipo Tag',
        'support.tagColor': 'Color Tag',
        'support.confirmDeleteTag': '¿Borrar tag?',
        'support.addTemplate': 'Añadir plantilla',
        'support.editTemplate': 'Editar plantilla',
        'support.templateContent': 'Contenido plantilla',
        'support.templatePreview': 'Vista previa',
        'support.templatePlaceholder': 'Markdown hab...',
        'support.noTemplates': 'Sin plantillas',
        'support.confirmDeleteTemplate': '¿Borrar plantilla?',
        'support.useTemplate': 'Usar plantilla',
        'support.loadTemplatesError': 'Error plantillas',
        'support.filterStatus': 'Filtrar estado',
        'support.reportedContent': 'Contenido reportado',
        'support.reportReason': 'Razon reporte',
        'support.reporter': 'Reportante',
        'support.reportPending': 'Pendiente',
        'support.reportReviewed': 'Revisado',
        'support.reportDismissed': 'Desestimado',
        'support.markReviewed': 'Marcar revisado',
        'support.dismissReport': 'Desestimar reporte',
        'support.noReports': 'Sin reportes',

        // API Keys
        'apiKeys.menuTitle': 'API Keys',
        'apiKeys.title': 'API Keys',
        'apiKeys.description': 'Gestione llaves p/ integraciones 3ros',
        'apiKeys.usageWarning': 'Use Keys p/ Home Assistant o Grafana sin login. ¡Manténgalas en secreto!',
        'apiKeys.myKeys': 'Mis llaves',
        'apiKeys.generateKey': 'Generar llave',
        'apiKeys.keyName': 'Nombre',
        'apiKeys.created': 'Creada',
        'apiKeys.lastUsed': 'Últ. uso',
        'apiKeys.noKeys': 'Sin llaves',
        'apiKeys.integrationExamples': 'Ejemplos integración',
        'apiKeys.haTitle': 'Home Assistant (REST)',
        'apiKeys.haInstructions': 'Añadir a configuration.yaml:',
        'apiKeys.curlTitle': 'cURL / Terminal',
        'apiKeys.generateDialogTitle': 'Generar API Key',
        'apiKeys.keyNameLabel': 'Nombre key (ej: Home Assistant)',
        'apiKeys.generateAction': 'Generar',
        'apiKeys.successDialogTitle': 'API Key generada',
        'apiKeys.copyWarning': 'Copie la key ahora. ¡No podrá verla de nuevo!',
        'apiKeys.createError': 'Error crear key',
        'apiKeys.deleteError': 'Error borrar key',
        'apiKeys.loadError': 'Error cargar keys',

        // Ajustes
        'settings.deleteAccount': 'Eliminar cuenta',
        'settings.deleteAccountDesc': 'Una vez que elimines tu cuenta, no hay vuelta atrás. Por favor, asegúrate.',
        'settings.deleteAccountConfirm': '¿Estás seguro de que quieres eliminar tu cuenta?',
        'settings.deleteAccountWarning': 'Esta acción es permanente y no se puede deshacer.',
        'settings.deleteAccountSuccess': 'Cuenta eliminada con éxito',
    }
};

export default es;
